'use client'
import { ItemImageCarouselWithOptions } from '@/app/ui/parts/default/sp/item/itemCarouselWithOptions'
import { ItemImageCarousel } from '@/app/ui/parts/default/sp/item/itemImageCarousel'
import { AddCartForm } from '@/app/ui/parts/default/sp/parts/addCartForm'
import { singleItemResponseType } from '@/lib/item/server'
import { serviceType } from '@/lib/service/server'
import { Fragment } from 'react'

type ItemMainInfoProps = {
  item: singleItemResponseType
  service: serviceType
  liked: boolean
}

export const ItemMainInfo: React.FC<ItemMainInfoProps> = ({
  service,
  item,
  liked,
}) => {
  const isOptionsHavingImages =
    item.item_options.filter((option) => option.stock == true).length > 0 &&
    item.item_options.every((option) => option.item_image_url !== '')
  if (item.item.stock && isOptionsHavingImages) {
    return (
      <Fragment>
        <ItemImageCarouselWithOptions
          service={service}
          item={item}
          liked={liked}
          like_count={item.item.like_count}
          one_day_sale={item.item.one_day_sale}
          campaigns={item.campaigns}
          options={item.item_options.filter((o) => o.stock == true)}
        />
      </Fragment>
    )
  }
  return (
    <Fragment>
      <ItemImageCarousel
        images={item.item_images}
        item_id={item.item.item_id}
        service_id={service.service_id}
        liked={liked}
        like_count={item.item.like_count}
        one_day_sale={item.item.one_day_sale}
        campaigns={item.campaigns}
        name={item.item.name}
      />
      <div className="item-main-info text-left m-4">
        <h1 className="text-base font-semibold text-[#424242]">
          {item.item.name}
        </h1>
      </div>
      <AddCartForm
        service={service}
        item={item.item}
        itemOptions={item.item_options.filter((o) => o.stock == true)}
      />
    </Fragment>
  )
}
